import { Component, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { SideBarComponent } from '../components/side-bar/side-bar.component';
import { HeaderComponent } from '../components/header/header.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FeedbackComponent } from "../../dashboard/components/feedback/feedback.component";
import { WindowSizeToolComponent } from "../../../tester/window-size-tool/window-size-tool.component";

@Component({
  selector: 'app-layout-main',
  imports: [SideBarComponent, /*HeaderComponent,*/ CommonModule, RouterOutlet, FeedbackComponent, WindowSizeToolComponent],
  templateUrl: './layout-main.component.html',
  styleUrl: './layout-main.component.css'
})
export class LayoutMainComponent {
  @ViewChild(SideBarComponent) sideBar!: SideBarComponent;
  currentPage: string = '';
  isFeedbackOpen: boolean = false;
  isUserInsideDashboard = false; 
  inWhichPageFromSidebar:string="";

  constructor (private cdr: ChangeDetectorRef) {
  }
  

  onCurrentPageChange (page: string): void {
    this.currentPage = page;
    this.cdr.detectChanges();
  }

  toggleFeedback (value: boolean) {
    this.isFeedbackOpen = value;
    if (this.isFeedbackOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

 handleDashboardStatus() {
     this.sideBar.toAvoidClickNationalRegional();
  }
}

